import { debounce, escape} from 'underscore';
import multiStepForm from './multi-step-form';
import initializeFollowingPlaceholder from './placeholder';
import DomainCheck from './domain-check';
import domainValidationAlert from './domain-validation-alert';
import { debounceTimeout } from './config';

const initialize = (signupEventsInstance, inboxSocial) => {
    // Display first tab
    multiStepForm.switchToTab(window.current_tab ? window.current_tab : 'signup_business_start');

    initializeFollowingPlaceholder('inbox', 'inbox-placeholder');

    $('body').on('input', '#domain', () => {
        document.getElementById('domain').value = document.getElementById('domain').value.toLowerCase();
    });

    // domain check start todo add to form validation instead of separate validation
    $('body').on('input', '#domain', debounce(() => {
        const domainName = document.getElementById('domain').value;
        if (domainName.length < 4) {
            return; // no need to check domain if it is too few chars long
        }

        const continueBtn = $('button[type="submit"][data-next_tab]:visible');

        const domainCheckInstance = new DomainCheck(domainName);
        if (!domainCheckInstance.isValid()) {
            domainValidationAlert('warning');
            continueBtn.attr('disabled', 'disabled');
            return;
        }

        domainCheckInstance.isAvailable((isAvailable) => {
            // switch alert messages based on domain availability
            domainValidationAlert(isAvailable ? 'success' : 'danger');
            continueBtn.attr('disabled', 'disabled');
            if (isAvailable) {
                Array.prototype.forEach.call(document.getElementsByClassName('current_domain_placeholder'), (el) => {
                    el.innerHTML = escape(domainName);
                });
                Array.prototype.forEach.call(document.getElementsByClassName('current_domain_input_placeholder'), (el) => {
                    el.setAttribute('placeholder', `user@${escape(domainName)}`);
                });
                Array.prototype.forEach.call(document.getElementsByClassName('current_domain_link'), (el) => {
                    el.setAttribute('href', `http://${escape(domainName)}`+el.getAttribute('data-append'));
                });
                inboxSocial.addCustomQueryParam('domainName', domainName);
                inboxSocial.addCustomQueryParam('successUrlPart', encodeURIComponent('#signup_business_social_connected'));
                // inboxSocial.registerLoginClickHandler();
                continueBtn.removeAttr('disabled');
            }
        });
    }, debounceTimeout));
    // domain check end
}

export default initialize;
